(function () {
  var BLUE     = "#6dc3e3";                 // change to any color
  var HOST_SEL = ".destini-locator-class";  // was #destini-locator — the id is store-specific (destini-locator-5464)
  var STYLE_ID = "custom-locator-theme";

  function styleEl() {
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.innerHTML = `
      #locator-template { background-color: ${BLUE} !important; }
      #locator-template .chakra-tabs__tab-panels { background-color: ${BLUE} !important; }
    `;
    return s;
  }

  function inject() {
    var host = document.querySelector(HOST_SEL);
    if (!host || !host.shadowRoot) return false;
    var sr = host.shadowRoot;
    if (sr.getElementById(STYLE_ID)) return true;
    sr.appendChild(styleEl());
    // re-add if the widget re-renders and removes it
    new MutationObserver(function () {
      if (!sr.getElementById(STYLE_ID)) sr.appendChild(styleEl());
    }).observe(sr, { childList: true });
    return true;
  }

  if (!inject()) {
    var obs = new MutationObserver(function () { if (inject()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 30000);
  }
})();